import { Injectable, inject } from '@angular/core';
import { EmployeesService } from '@core/api/employees/employees.service';
import { LocalRuleSettingsService } from '../rules/local-rule-settings.service';
import { ProjectDataSource, ProjectSettings } from './project-data';
@Injectable()
export class LocalProjectDataSource implements ProjectDataSource {
    private readonly settings = inject(LocalRuleSettingsService);
    private readonly employees = inject(EmployeesService);
    read() {
        return this.settings.read<ProjectSettings>('projects', { rows: [], hiddenColumns: [] });
    }
    save(value: ProjectSettings) {
        this.settings.save('projects', value);
    }
    people() {
        return this.employees.getEmployeeSelectionOptions();
    }
}
